<template>
  <div id="cotizadorVida">
    <CCardGroup class="col-lg-12 col-lg-12 p-0">
      <CCol>
        <CCard>
          <CCardBody class="d-flex flex-wrap justify-content-around">
            <div class="form-group col-sm-12 col-md-4 col-lg-2">
              <label for="">No. Agente</label>
              <input
                type="text"
                class="form-control"
                :value="pId_Agente"
                disabled
              />
            </div>
            <div class="form-group col-12 col-md-8 col-lg-6">
              <label for="">Agente</label>
              <input
                type="text"
                class="form-control"
                :value="agentName ? agentName : '-- Agente no encontrado'"
                disabled
              />
            </div>
            <div class="form-group col-12 col-lg-4">
              <label for="">No. Cotización</label>
              <input
                type="number"
                class="form-control"
                :value="pNum_Cotizacion"
                disabled
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CCardGroup>

    <CCardGroup>
      <CCol>
        <CCard>
          <CCardBody>
            <Title text="Detalles generales" />

            <div class="d-flex flex-wrap" id="general">
              <div class="form-group col-3 col-md-4">
                <label for="">Suma asegurada por fallecimiento</label>
                <input
                  type="text"
                  name="sumaAseg"
                  class="form-control"
                  required
                  v-model="sumaAseg"
                  @keyup="validateDetallesGenerales"
                  @blur="setNumberFormat"
                />
              </div>

              <div class="form-group col-3 col-md-4 col-lg-3">
                <label for="">Plan</label>
                <select
                  name="pId_Lin_Negocio"
                  class="form-control"
                  data-type="select"
                  v-model="pId_Lin_Negocio"
                  required
                  @change="validateDetallesGenerales($event, 'plan')"
                >
                  <option value="">-- Seleccione</option>
                  <option
                    :data-idBien="plan.CVE_T_BIEN"
                    :value="plan.ID_LIN_NEGOCIO"
                    v-for="(plan, i) in lineas"
                    :key="i"
                  >
                    {{ plan.NOM_LINEA_WEB }}
                  </option>
                </select>
              </div>
              <div
                class="form-group col-sm-6 col-md-4 col-lg-2"
                style="min-width: 200px"
              >
                <label for="">Fecha de nacimiento</label>
                <input
                  type="date"
                  class="form-control F_NACIMIENTO"
                  data-type="date"
                  name="pF_Nacimiento"
                  required
                  v-model="fecha_nacimiento"
                  @keyup="validateDetallesGenerales"
                />
              </div>
              <div class="form-group col-sm-6 col-md-4 col-lg-2">
                <label for="">Edad</label>
                <input
                  type="number"
                  class="form-control text-center"
                  name="computedAge"
                  :value="systemAge"
                  disabled
                />
              </div>

              <div class="form-group col-4 cell-12 tablet-sm-12 tablet-bg-8">
                <label for="">Nombre del asegurado</label>
                <input
                  type="text"
                  name="pNombre_Persona"
                  class="form-control NOMBRE_PERSONA"
                  data-type="input"
                  required
                  v-model="nombre"
                  @keyup="validateDetallesGenerales"
                />
              </div>
              <div class="form-group col-4 cell-12 tablet-sm-12 tablet-bg-8">
                <label for="">Apellido paterno</label>
                <input
                  type="text"
                  name="pApellido_Paterno"
                  class="form-control APELLIDO_PATERNO"
                  data-type="input"
                  required
                  v-model="app"
                  @keyup="validateDetallesGenerales"
                />
              </div>
              <div class="form-group col-4 cell-12 tablet-sm-12 tablet-bg-8">
                <label for="">Apellido materno</label>
                <input
                  type="text"
                  name="pApellido_Materno"
                  class="form-control APELLIDO_MATERNO"
                  data-type="input"
                  required
                  v-model="apm"
                  @keyup="validateDetallesGenerales"
                />
              </div>
              <div class="form-group col-3 col-md-4">
                <label for="">Sexo</label>
                <select
                  name="pCve_Sexo"
                  class="form-control CVE_SEXO"
                  data-type="select"
                  v-model="CVE_SEXO"
                  required
                  @change="validateDetallesGenerales"
                >
                  <option value="">-- Selecciona</option>
                  <option value="M">Masculino</option>
                  <option value="F">Femenino</option>
                </select>
              </div>
              <div class="form-group col-12 d-flex justify-content-end">
                <button
                  class="btn btn-primary"
                  @click="handleDetallesGenerales"
                >
                  Continuar
                </button>
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CCardGroup>

    <CCardGroup
      class="d-flex flex-wrap justify-content-between align-items-stretch p-0"
      v-if="isCompleted"
    >
      <CCol class="col-6 col-sm-12 col-md-12">
        <CCard class="flex-grow-1">
          <CCardBody>
            <Title text="Coberturas" />
            <div class="d-flex flex-wrap justify-content-start mt-3">
              <div class="form-group col-sm-12 col-md-12 col-lg-12 col-4  cobs_container"
                v-for="(factor, i) in coberturas" id="cobs_container" :key="i" v-show="factor.B_OBLIGATORIO != 'V'">
                <Checkbox
                  :label="factor.NOM_CTO_COB"
                  :name="factor.ID_COBERTURA"
                  :class="factor.NOM_CTO_COB"
                  :data-clave="factor.CVEL_T_COBERTURA"
                  :data-idCobertura="factor.ID_COBERTURA"
                  :data-nombre="factor.NOM_CTO_COB"
                  :data-desclimax="factor.DESCLIMMAX"
                  :data-saCob="factor.SA_DeCobertura"
                  class="mt-3 mb-2"
                  @switchMethod="handleCobs($event)"
                  @onMounted="switchComponentMounted = true"/>
                <select name="" class=" mb-2 form-control hidden__element d-none col-12" v-if="factor.CoberturasHijas.length > 0">
                  <option value="">-- Seleccione</option>
                  <option :data-idCobertura="variante.ID_COBERTURA" :data-desclimax="variante.DESCLIMMAX"
                    :data-sa_decobertura="variante.SA_DeCobertura" :value="`${variante.CVEL_T_COBERTURA}`"
                    v-for="(variante, k) of factor.CoberturasHijas" :key="k" >
                    {{ variante.NOM_CTO_COB }}
                  </option>
                </select>
                <input v-if="factor.DESCLIMMAX != 'NO IMPRIMIR'" :name="factor.ID_COBERTURA + 'amount'"
                  type="text" min="0" :max="factor.SA_AMPARADA > 0 ? factor.SA_AMPARADA : null"
                  class="form-control hidden__element d-none cob__amount" placeholder="Monto" />
              </div>

              <div class="col-12 mt-3 text-dark">
                <label for="">BENEFICIOS ADICIONALES</label>
              </div>
              <div
                class="form-group col-5 cel-6 tablet-sm-3 tablet-bg-6"
                v-if="CVE_SEXO == 'F'"
              >
                <Checkbox
                  name="MUJER"
                  label="MUJER"
                  class="mt-3 mb-2 B_MUJER"
                  data-type="checkbox"
                  :checked="beneficios.mujer == 'V' ? true : false"
                  @switchMethod="handleBeneficios($event, 'mujer')"
                />
              </div>
              <div class="form-group col-5 cel-6 tablet-sm-3 tablet-bg-6">
                <!-- @switchMethod="handleCobsAdicional('fumador', $event)" -->
                <Checkbox
                  name="FUMADOR"
                  label="¿ES FUMADOR?"
                  class="mt-3 mb-2 B_FUMADOR"
                  data-type="checkbox"
                  :checked="beneficios.fumador == 'V' ? true : false"
                  @switchMethod="handleBeneficios($event, 'fumador')"
                />
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CCardGroup>

    <!-- Total -->
    <CCardGroup v-if="isCompleted">
      <CCol>
        <CCard>
          <CCardBody>
            <Title text="Resúmen" />
            <div class="d-flex flex-wrap justify-content-between">
              <div class="table-responsive col-lg-6 tablet-bg-6">
                <table v-if="esCambio" class="table" style="border: 1px dashed gray">
                  <thead class="text-center">
                    <th></th>
                    <th>Prima</th>
                    <th>Inicial</th>
                    <th>Subsecuente</th>
                    <th>Total</th>
                  </thead>
                  <tbody>
                    <tr v-for="(formaPago, i) in formasPago" :key="i">
                      <td>
                        <input
                          type="radio"
                          name="formaPago"
                          :checked="formaPago.FPAGODFT == '*'"
                          :value="formaPago.ID_FORMA_PAGO"
                          @change="handleFormaPago($event)"
                        />
                      </td>
                      <th>{{ formaPago.NOM_FORMA_PAGO }}</th>
                      <td>{{ formaPago.ImpPrimaTotalRbo }}</td>
                      <td>{{ formaPago.ImpPrimaSubs }}</td>
                      <td>{{ formaPago.ImpPrimaTotal }}</td>
                    </tr>
                    <tr v-if="formasPago.length">
                      <td colspan="5" class="bg-light text-center">
                        <i class="text-danger">Incluye gastos de expedición</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="col-lg-6 col-8 tablet-bg-6 align-self-end mb-3 mt-3">
                <div class="buttons__options__container">
                  <button
                    type="button"
                    class="btn button__items btn-dark btn__special--info"
                    @click="cotizar"
                  >
                    <i class="fas fa-calculator"></i> Cotizar
                  </button>

                  <button
                    class="btn button__items btn-dark btn__special--success"
                    @click="guardar"
                  >
                    <i class="fas fa-save"></i> Guardar
                  </button>
                  <button
                    class="btn button__items btn-dark btn__special--danger"
                    @click="nuevaCotizacion"
                  >
                    <i class="fas fa-sync"></i> Nueva
                  </button>
                  <button
                    class="btn button__items btn-dark btn__special--warning"
                    v-if="showPrintButton"
                    @click="handlePrint"
                  >
                    <i class="fas fa-print"></i> Imprimir
                  </button>
                </div>
              </div>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CCardGroup>
  </div>
</template>

<script>
// Components
import Title from "../../../componentes/Textos/Title";
import Button from "../../../componentes/Buttons/Button";
import Tooltip from "../../../componentes/Tooltip";
import Checkbox from "../../../componentes/Buttons/Switch.vue";

// Helper
import { form, format, date } from "../../../assets/helpers/index";

// Modelo
import { CotViService as API } from "./services";
// Handlers
import { Coberturas } from "./handlers/Coberturas";

export default {
  components: {
    Title,
    Button,
    Tooltip,
    Checkbox,
  },
  data: function () {
    return {
      switchComponentMounted: undefined,
      switchComponentProm: new Promise((resolve, reject) => {
        const asking = setInterval(() => {
          if (this.switchComponentMounted) {
            clearInterval(asking);
            console.log(375);
            resolve("ok");
          }
        }, 500);
      }),

      cotizacionNueva: false,

      // Static data
      pId_Empresa: 8,
      pId_Agente: 137,
      idUsuario: "WEB", //localStorage.getItem("userId"),
      agentName: null,
      idMainCob: "974", // Cobertura básica fallecimiento
      mainCob: {},

      initialSumaAseg: 0,

      ID_PRODUCTO: null,
      ID_VERSION: null,
      pId_Cotizacion: null,
      pNum_Cotizacion: null,

      idFormaPago: 0,

      // Datos generales
      removeAllCobs: false,
      isCompleted: false,
      sumaAseg: null,
      fecha_nacimiento: null,
      nombre: null,
      app: null,
      apm: null,
      CVE_SEXO: "",
      pId_Lin_Negocio: "",
      idBien: null || "PERVI",
      sumaAsegChanged: false,
      planChanged: false,

      // Coberturas
      beneficios: {
        mujer: "F",
        fumador: "F",
      },
      initialCobState: [],
      showPrintButton: false,

      // API response =====
      // Cat paquete
      ID_PAQUETE: null,

      // Grabacot
      agrupadores: {
        idTarifa: null,
        idVersion: null,
      },

      // payment
      formasPago: [],

      infoProducto: null,
      lineas: null,
      monedas: null,
      numCotizacion: null,
      catPaquete: null,
      grabaCot: null,
      coberturas: null,
      importes: null,
      datosAseg: null,
      esCambio: true,
    };
  },
  methods: {
    validateDetallesGenerales(e, type = null) {
      const target = e.target;
      this.isCompleted = false;

      if (type == "plan") {
        this.$router.replace({
          query: { ...this.$route.query, linea: target.value },
        });
        this.removeAllCobs = true;

        const idBien = target.selectedOptions[0].getAttribute("data-idBien");
        this.idBien = idBien;

        this.planChanged = true;
      }

      if (target.name == "sumaAseg") {
        this.sumaAsegChanged = true;
      }

      this.isCompleted = false;
    },
    async handleDetallesGenerales() {
      const fakeForm = document.querySelector("#general");
      const isValid = form.validate(fakeForm);

      this.idBien =
        this.idBien ||
        document
          .querySelector("[name='pId_Lin_Negocio']")
          .selectedOptions[0].getAttribute("data-idbien");

      if (!isValid) {
        this.$swal("Error", "Todos los campos son requeridos");
        return;
      }

      if (this.sumaAseg == 0) {
        this.$swal("Error", "La suma asegurada debe ser mayor");
        return;
      }

      if (this.planChanged && this.cotizacionNueva) {
        if (!this.ID_PAQUETE) {
          console.log(490);
          await this.setPaquete();
        }

        const validCot = await this.setCotizacion();

        if (!validCot) {
          console.log(497);
          return;
        }
        console.log(500);
      }

      await this.setPaquete();
      const validCot = await this.setCotizacion();
      console.log(505, validCot);
      if (!validCot) {
        return;
      }

      await this.setCoberturas(false);
      console.log(511);

      if (this.sumaAsegChanged && this.sumaAseg != this.initialSumaAseg) {
        // Actualiza cob principal
        await API.updateCobs(this, this.idMainCob, "MTE", "V", this.sumaAseg);
        this.esCambio = false;
      } else {
        await this.setCotizacion();
      await API.cotizaCobs(this);
      this.formasPago = await API.getImportes(
        this.pId_Cotizacion,
        this.pId_Agente
      );
      }

      
      console.log(517);
      this.isCompleted = true;
      
      if (!this.planChanged && !this.cotizacionNueva) {
        await this.setSavedCobs();
      }

      
    },

    async setCotizacion() {
      const grabaCotResponse = await API.grabaCotizacion(this);
      console.log("set cotizacion", grabaCotResponse);
      if (!grabaCotResponse) {
        return false;
      }
      this.agrupadores.idTarifa = grabaCotResponse.pId_Agp_Tarifa;
      this.agrupadores.idVersion = grabaCotResponse.pId_VersTr_AgpTr;
      return true;
    },

    async setPaquete() {
      this.ID_PAQUETE = await API.getPaquete(
        this.ID_PRODUCTO,
        this.ID_VERSION,
        this.$route.query.linea
      );
    },

    async setCoberturas(waitForMountedSwitch = true) {
      this.coberturas = await API.getCoberturas(this);
      if (waitForMountedSwitch) {
        await this.switchComponentProm;
      }
    },

    async handlePrint() {
      if (!this.agrupadores.idTarifa || !this.agrupadores.idVersion) {
        await this.setCotizacion();
      }
      await API.printPDF(this);
    },
    handleBeneficios(check, type) {
      return (this.beneficios[type] = check.checked ? "V" : "F");
    },

    handleCobs(event) {
      const active = event.checked;
      const container = event.parentElement.parentElement.parentElement;
      const hiddenElements = container.querySelectorAll(".hidden__element");

      hiddenElements.forEach((hiddenElement) => {
        if (active) {
          hiddenElement.classList.remove("d-none");
        } else {
          hiddenElement.value = "";
          hiddenElement.classList.add("d-none");
        }
      });
    },

    async cotizar() {
      this.esCambio = true;
      if (this.sumaAseg == 0) {
        this.$swal("Error", "Suma asegurada no válida");
        return;
      }
      const { isValid, cobsToUpdate, errorString } = Coberturas.compare(
        this.initialCobState
      );

      if (!isValid) {
        this.$swal({
          icon: "",
          title: "Se encontraron los siguientes errores",
          html: errorString,
        });
        return;
      }


      for (const cob of cobsToUpdate) {
        const { idcobertura, clave, active, monto } = cob;
        const successUpdating = await API.updateCobs(this, idcobertura, clave, active, monto);

        if (!successUpdating) {
          return
        }
      }
      await this.setCotizacion();
      await API.cotizaCobs(this);
      this.formasPago = await API.getImportes(
        this.pId_Cotizacion,
        this.pId_Agente
      );
      console.log(613);
      this.initialCobState = Coberturas.getInitialState();
    },

    async guardar() {
      const method = document.querySelector("[name='formaPago']:checked");

      if (method) {
        this.idFormaPago = method.value;
      }

      if (!this.idFormaPago) {
        this.$swal("Error", "Selecciona una forma de pago");
        return;
      }

      await API.cotizaCobs(this);
      await this.setCotizacion();

      const printPDF = await this.$swal.fire({
        icon: "success",
        title: `Cotización guardada <div class="mt-2 mb-2" style="font-size: 0.8em">¿Imprimir comprobante?</div>`,
        text: "Puede imprimir el comprobante en otro momento en las opciónes de abajo o en el modulo 'Consulta'",
        showCancelButton: true,
        cancelButtonText: "No gracias",
        confirmButtonText: "Imprimir",
      });

      if (printPDF.isConfirmed) {
        await API.printPDF(this);
      }
      this.showPrintButton = true;
    },

    handleFormaPago(e) {
      this.idFormaPago = e.target.value;
    },

    async nuevaCotizacion() {
      this.sumaAseg = 0;
      this.initialSumaAseg = this.sumaAseg;
      this.nombre = "",
      this.app = "";
      this.apm = "";
      this.fecha_nacimiento = null;
      this.CVE_SEXO = "";
      this.isCompleted = false;
      this.sumaAsegChanged = false;
      this.beneficios.mujer = "F";
      this.beneficios.fumador = "F";
      this.pId_Lin_Negocio = null;
      this.initialCobState = [];
      // document.querySelector("[name='pId_Lin_Negocio']").selectedIndex = 0
      this.formasPago = []
      this.showPrintButton = false;
      await this.init();
    },

    // Edición de cotización ya hecha
    setNumberFormat(e) {
      if (e.target.value != "") {
        const monto = format.number(e.target.value);
        e.target.value = format.money(monto);
        this.sumaAseg = format.money(monto);
      } else e.target.value = "0.00";
    },

    // ============ Initial settup

    async setLineas() {
      this.lineas = await API.getLineas(
        this.pId_Empresa,
        this.ID_PRODUCTO,
        this.ID_VERSION,
        this.pId_Agente
      );
    },
    async setInfoProducto() {
      const { cotID, cotNum, linea } = this.$route.query;
      this.pId_Cotizacion = cotID;
      this.pNum_Cotizacion = cotNum;
      this.pId_Lin_Negocio = linea;

      const { ID_PRODUCTO, ID_VERSION } = await API.getInfoProducto(
        this.pId_Empresa,
        this.pId_Agente
      );
      this.ID_PRODUCTO = ID_PRODUCTO;
      this.ID_VERSION = ID_VERSION;
    },
    async setMonedas() {
      this.monedas = await API.getMonedas(this.ID_PRODUCTO, this.ID_VERSION);
    },

    async init() {
      this.cotizacionNueva = true;
      // Obtiene datos del producto
      await this.setInfoProducto();

      // Obtiene el id cotizacion
      const { pId_Cotizacion, pNum_Cotizacion } = await API.getIdCotizacion(
        this.idUsuario,
        this.pId_Agente
      );
      this.pId_Cotizacion = pId_Cotizacion;
      this.pNum_Cotizacion = pNum_Cotizacion;

      // Agrega detalles de la cotizacion para que cualquier cambio posterior sea sobre esta misma.
      this.$router.replace({
        query: { cotID: this.pId_Cotizacion, cotNum: this.pNum_Cotizacion },
      });

      // Obtiene las líneas (planes)
      await this.setLineas();
      this.pId_Lin_Negocio = null;

      // Obtiene monedas
      await this.setMonedas();
    },

    async loadCotizacion() {
      this.cotizacionNueva = false;
      await this.setInfoProducto(), 
      await this.setLineas();
      await this.setMonedas();
      await this.setDatos();
      // Valida si está completo
      if (!this.$route.query.linea) {
        this.isCompleted = false;
        return this.$swal("Error", "Por favor selecciona un paquete para poder continuar");
      }
      await this.setPaquete();
      this.isCompleted = true;
      await this.setCoberturas();
      await this.setSavedCobs();


      this.formasPago = await API.getImportes(
        this.pId_Cotizacion,
        this.pId_Agente
      );

      // Significa que si guardó la cotización
      if (this.formasPago.length > 0) {
        this.showPrintButton = true;
      }
    },

    async setSavedCobs() {
      const cobs = await API.getCoberturasData(
        this.pId_Cotizacion,
        this.pId_Lin_Negocio
      );

      if (cobs.length > 0) {
        const coberturas = cobs.filter(
          (cob) => cob.ID_COBERTURA != this.idMainCob
        );
        await Coberturas.setSaved(coberturas, this.switchComponentProm);

        const mainCob = cobs.filter(
          (cob) => cob.ID_COBERTURA == this.idMainCob
        )[0];

        this.mainCob = mainCob;
        this.sumaAseg = format.money(mainCob.SA_AMPARADA);
      }
      this.initialCobState = Coberturas.getInitialState();
    },
    async setDatos() {
      const datos = await API.getCotizacionData(
        this.pId_Cotizacion,
        this.pId_Lin_Negocio,
        this.pId_Agente
      );

      if (!datos) {
        return;
      }

      this.apm = datos.APELLIDO_MATERNO;
      this.app = datos.APELLIDO_PATERNO;
      this.CVE_SEXO = datos.CVE_SEXO;
      this.fecha_nacimiento = format.date(datos.F_NACIMIENTO, "aaaa-mm-dd");
      this.nombre = datos.NOMBRE_PERSONA;

      // Manage beneficios adicionales
      this.beneficios.mujer = datos.B_BENEF_MUJER;
      this.beneficios.fumador = datos.B_FUMADOR;
    },
  },
  computed: {
    systemAge() {
      if (!this.fecha_nacimiento) {
        return 0;
      }
      return date.getAge(this.fecha_nacimiento);
    },
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(params) {
        if (Object.keys(params).length == 0) {
          this.nuevaCotizacion();
        }
      },
    },
  },
  async mounted() {
    const { cotID, cotNum } = this.$route.query;
    if (cotID > 0 && cotNum > 0) {
      // Edición de cotización
      await this.loadCotizacion();
      this.initialSumaAseg = this.sumaAseg;
      return;
    }
    // Creación de cotización
    this.nuevaCotizacion();
  },
};
</script>